<template>
    <div class="pt-2.5 md:py-2.5">
        <div class="text-gray-900 leading-tight">
            <div
                class="flex justify-between items-center pb-2 md:pt-2.5"
                :class="{'md:border-b md:border-dashed md:border-gray-200':foldable,'border-b border-dashed border-gray-200':!foldable}"
            >
                <div class="text-base xs:text-lg text-gray-900">
                    {{ data.fundCode }} {{ data.fundName }} {{ needTargetCurrency?`(${data.currencyCH})`:'' }}
                </div>
                <button
                    v-show="foldable"
                    class="inline-block transition duration-200 md:hidden"
                    :class="data.isFold ? '-rotate-90' : ''"
                    @click="data.isFold = !data.isFold"
                >
                    <SvgIcon
                        icon-name="expand_more"
                        class="text-black w-7 h-7 cursor-pointer"
                    />
                </button>
            </div>
            <div class="relative">
                <slot name="data" />
                <div class="absolute right-0 bottom-0 lg:bottom-1/2 lg:translate-y-1/2">
                    <slot name="openButton">
                        <button
                            v-show="!data.isRedeem"
                            :disabled="data.disable"
                            class="btn btn-gray btn-sm rounded-full"
                            type="button"
                            @click="data.isRedeem = true"
                        >
                            {{ openButtonName }}
                        </button>
                    </slot>
                </div>
            </div>
            <div
                v-if="!!data.fundMsg.length"
                class="bg-gray-50 px-2.5 py-1.5 md:py-2.5 text-warning text-sm xs:text-base mb-2.5"
            >
                {{ data.fundMsg }}
            </div>
        </div>
        <div
            tabindex="0"
            class="collapse"
            :class="{'collapse-open':data.isRedeem, 'collapse-close':!data.isRedeem}"
        >
            <div class="collapse-content px-0">
                <div class="bg-green-100 border-dashed border rounded md:rounded-md border-secondary px-3 py-3.5 xs:px-4">
                    <!-- 藍色框內容 -->
                    <div class="lg:flex items-start">
                        <div class="lg:flex">
                            <div class="flex">
                                <div class="md:flex items-start md:mr-5">
                                    <Radio
                                        v-model:checkedValue="data.redeemBy"
                                        value="UNIT"
                                        :name="`radioSelect${idx}`"
                                        text="依單位數"
                                        class="pr-3 mb-1.5 md:m-0 flex-shrink-0 xs:text-base md:text-lg md:h-12"
                                    />
                                    <div>
                                        <!-- 數字鍵盤，左下角多變成小數點 -->
                                        <input
                                            ref="inputUnit"
                                            v-model.number="data.redeemUnit"
                                            :disabled="data.redeemBy!=='UNIT'"
                                            inputmode="decimal"
                                            autocomplete="off"
                                            class="input-base hidden md:block w-[15.9375rem]"
                                            placeholder=""
                                            @input="validateUnit($event,data)"
                                        >
                                        <p
                                            v-if="data.redeemBy==='UNIT'"
                                            class="error-msg text-right hidden md:block"
                                        >
                                            {{ data.errorMsgRedeemUnit }}
                                        </p>
                                    </div>
                                </div>
                                <div>
                                    <div class="md:flex items-start lg:mr-5">
                                        <Radio
                                            v-model:checkedValue="data.redeemBy"
                                            value="PERCENT"
                                            :name="`radioSelect${idx}`"
                                            text="依比例"
                                            class="pr-3 mb-1.5 md:m-0 flex-shrink-0 xs:text-base md:text-lg md:h-12"
                                        />
                                        <div class="items-center mr-6 hidden md:flex">
                                            <input
                                                ref="inputPercent"
                                                v-model.trim="data.redeemPercent"
                                                :disabled="data.redeemBy!=='PERCENT'"
                                                inputmode="numeric"
                                                autocomplete="off"
                                                placeholder=""
                                                maxlength="3"
                                                class="input-base w-20 percent pr-6"
                                                @input="validatePercent(data)"
                                            >
                                            <SvgIcon
                                                icon-name="percent"
                                                :class="[data.redeemBy!=='PERCENT'?'text-gray-200':'text-gray-700']"
                                                class=" w-5 h-5 -ml-6"
                                            />
                                        </div>
                                    </div>
                                    <p
                                        v-if="data.redeemBy==='PERCENT'"
                                        class="error-msg text-right md:mr-5 lg:mr-10  hidden md:block"
                                    >
                                        {{ data.errorMsgRedeemPercent }}
                                    </p>
                                </div>
                            </div>
                            <!-- for手機版input -->
                            <div class="md:hidden">
                                <div v-show="data.redeemBy==='UNIT'">
                                    <!-- 數字鍵盤，左下角多變成小數點 -->
                                    <input
                                        ref="inputUnitM"
                                        v-model.number="data.redeemUnit"
                                        inputmode="decimal"
                                        autocomplete="off"
                                        class="input-base"
                                        @input="validateUnit($event,data)"
                                    >
                                    <p class="error-msg text-right">
                                        {{ data.errorMsgRedeemUnit }}
                                    </p>
                                </div>
                                <div v-show="data.redeemBy==='PERCENT'">
                                    <div class="flex items-center">
                                        <input
                                            ref="inputPercentM"
                                            v-model.trim="data.redeemPercent"
                                            inputmode="numeric"
                                            autocomplete="off"
                                            class="input-base pr-6"
                                            maxlength="3"
                                            @input="validatePercent(data)"
                                        >
                                        <SvgIcon
                                            icon-name="percent"
                                            class="w-5 h-5 -ml-6"
                                            :class="[data.redeemBy==='PERCENT'?'text-gray-200':'text-gray-700']"
                                        />
                                    </div>
                                    <p class="error-msg text-right">
                                        {{ data.errorMsgRedeemPercent }}
                                    </p>
                                </div>
                            </div>
                            <!-- 手機版inputEND -->
                        </div>
                        <div class="relative md:flex-grow">
                            <div class="border-t lg:border-0 border-dashed border-gray-200 mt-3 pt-2.5 lg:pt-0 lg:mt-0 lg:flex items-center md:h-12">
                                <p class="text-gray-400 text-sm md:text-xs flex-shrink-0 mr-3">
                                    預估{{ openButtonName }}金額<span class="lg:block"> {{ `(${currencyData.currencyText})` }}</span>
                                </p>
                                <p class="text-base xs:text-lg ">
                                    {{ addComma(redeemAmount) }}
                                </p>
                            </div>
                            <slot name="closeButton">
                                <div class="absolute lg:static right-0 bottom-0 flex justify-end mb-1.5 md:mb-0">
                                    <button
                                        class="btn-text text-primary border-b border-primary"
                                        type="button"
                                        @click="handleCancel()"
                                    >
                                        取消變更
                                    </button>
                                </div>
                            </slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { toRef, ref, watchEffect, nextTick, computed } from 'vue';
import { integer, intMinMax, minMax } from '@/utils/rules/customRules';
import { addComma } from '@/utils/number/addComma';
import Radio from '@/components/radios/Radio.vue';
import Decimal from 'decimal.js';

export default {
    components: {
        Radio,
    },
    props: {
        idx: {
            type: Number,
            required: true,
        },
        foldable: {
            type: Boolean,
            default: false,
        },
        openButtonName: {
            type: String,
            default: '變更',
        },
        field: {
            type: Object,
            required: true,
        },
        needTargetCurrency: {
            type: Boolean,
            default: false,
        },
        currencyData: {
            type: Object,
            default: () => { },
        },
        redeemAmountRule: {
            type: String,
            default: '',
        },
        floatNum: {
            type: [String, Number],
            default: 0
        }
    },
    setup(props) {
        const data = toRef(props, 'field');
        const inputUnit = ref(null);
        const inputUnitM = ref(null);
        const inputPercent = ref(null);
        const inputPercentM = ref(null);

        const handleCancel = () => {
            // emit('update:isRedeem', false);
            data.value.isRedeem = false;
            // 點擊取消變更要歸0
            data.value.redeemPercent = 0;
            data.value.redeemUnit = 0;
            data.value.errorMsgRedeemPercent = '';
            data.value.errorMsgRedeemUnit = '';
        };

        const validateUnit = (e, data) => {
            const rule1 = data.rule1;
            const { val, errorMessage } = intMinMax({
                value: e.target.value,
                maxNum: data.unit,
                floatNum: rule1 ? null : 5,
                minMaxMsg: '請小於持有單位數',
            });

            data.errorMsgRedeemUnit = errorMessage;
            if (rule1 && data.errorMsgRedeemUnit === '請輸入正整數') {
                data.errorMsgRedeemUnit = '單位數須為整數，且不可少於1';
            }
            e.target.value = val;
        };

        const validatePercent = (data) => {
            data.redeemPercent = isNaN(Number(data.redeemPercent)) ? data.redeemPercent : Number(data.redeemPercent);
            const errorMsg = integer(data.redeemPercent) || minMax(data.redeemPercent, 1, 100);
            errorMsg ? data.errorMsgRedeemPercent = errorMsg : data.errorMsgRedeemPercent = '';
        };

        const redeemAmount = computed(() => {
            let amount = 0;
            if (!data.value.errorMsgRedeemUnit && !data.value.errorMsgRedeemPercent) {
                if (data.value.redeemBy === 'UNIT') {
                    if (!!Number(data.value.redeemUnit) && !isNaN(Number(data.value.redeemUnit))) {
                        // 依單位數: (贖回單位數/持有單位數) * 預估帳戶價值  = 預估轉出金額
                        amount = new Decimal(data.value.redeemUnit).dividedBy(data.value.unit).times(data.value.acnoValue);
                    }
                }
                if (data.value.redeemBy === 'PERCENT') {
                    if (!!Number(data.value.redeemPercent) && !isNaN(Number(data.value.redeemPercent))) {
                        // 依比例: (贖回比例/100)*預估帳戶價值 = 預估轉出金額
                        amount = new Decimal(data.value.redeemPercent).dividedBy(100).times(data.value.acnoValue);
                    }
                }
            }
            // return parseFloat(Decimal.round(amount)).toFixed(5);
            if (props.redeemAmountRule === 'round') {
                amount = parseFloat(Decimal.round(amount));
            };
            if (props.redeemAmountRule === 'float') {
                amount = parseFloat(amount).toFixed(Number(props.floatNum));
            };
            // return props.currencyData.currency === 'NTD' ? parseFloat(Decimal.round(amount)) : parseFloat(amount).toFixed(2);
            return amount;
        });

        watchEffect(() => {
            data.value.redeemAmount = redeemAmount.value;
            // 點擊radio自動focus
            if (data.value.redeemBy === 'UNIT') {
                data.value.redeemPercent = 0;
                data.value.errorMsgRedeemPercent = '';
                nextTick(() => {
                    if (inputUnit.value) inputUnit.value.focus();
                    if (inputUnitM.value) inputUnitM.value.focus();
                });
            }
            if (data.value.redeemBy === 'PERCENT') {
                data.value.redeemUnit = 0;
                data.value.errorMsgRedeemUnit = '';
                nextTick(() => {
                    if (inputPercent.value) inputPercent.value.focus();
                    if (inputPercentM.value) inputPercentM.value.focus();
                });
            }
        });

        return {
            data,
            handleCancel,
            inputUnit,
            inputUnitM,
            inputPercent,
            inputPercentM,
            validateUnit,
            validatePercent,
            addComma,
            redeemAmount
        };
    }
};
</script>
<style lang="scss" scoped>
.collapse.collapse-open {
    overflow: initial;
    .collapse-content {
        overflow: initial;
    }
}
.gray-dashed:not(:first-child) {
    @apply border-t border-dashed border-gray-200 pt-3 mt-3;
}
.input-base {
    @apply text-left;
}
</style>
